var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23.5273C17.8513 23.5273 23 18.3786 23 12.0273C23 5.67607 17.8513 0.527344 11.5 0.527344C5.14873 0.527344 0 5.67607 0 12.0273C0 18.3786 5.14873 23.5273 11.5 23.5273Z",
    fill: "#B4BCD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8236 8.45576L17.8343 7.48908V7.27734H14.3322L11.8367 13.4887L8.99755 7.27734H5.32566V7.48908L6.5061 8.90967C6.56298 8.96143 6.60703 9.02573 6.63474 9.09748C6.66245 9.16922 6.67307 9.24643 6.66575 9.32299V14.9093C6.68316 15.0085 6.67679 15.1105 6.64716 15.2068C6.61752 15.3031 6.56547 15.391 6.49528 15.4633L5.16602 17.076V17.285H8.93734V17.0733L7.6074 15.4626C7.53622 15.3907 7.48263 15.3032 7.45083 15.2071C7.41903 15.111 7.40987 15.0088 7.42407 14.9086V10.0779L10.7347 17.2891H11.119L13.9662 10.0779V15.8212C13.9662 15.9727 13.9662 16.0038 13.8668 16.1033L12.8426 17.0943V17.3067H17.8106V17.095L16.8236 16.1283C16.7809 16.096 16.7477 16.0527 16.7278 16.003C16.7079 15.9533 16.702 15.899 16.7107 15.8462V8.73784C16.7017 8.68505 16.7075 8.63082 16.7273 8.58107C16.7471 8.53133 16.7809 8.48798 16.8236 8.45576Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.56a8fabafb1a4172d36af2d0bf862484.svg";
export { ForwardRef as ReactComponent };